
const Definition = {

    id: "lanqq",
    plan_level: 2,
    name: "Lanqq",
    path: "team/lanqq/components/Landing",
    preview_image: "https://img.freepik.com/free-vector/gradient-blue-background_23-2149322706.jpg",
    colors: {
        background: "#001538",
        background_alt: "#000F29",
        surface: "#021E4A",
        surface_alt: "#113F7F",
        header_background: "#001538",
        text: "#ffffff",
        text_soft: "#95BEF1",
        text_muted: "#8A9BB8",
        primary: "#F7C95E",
        primary_dark: "#F09F26",
        on_primary: "#001538",
        secondary: "#3BB0D4",
        accent: "#4689E0",
        success: "#46E07A",
        danger: "#E04658"
    }

};

export default Definition;
